import { routesNavBar } from '@/constants/routes'
import { INavBarItem } from '@/models/navbar'
import { defineStore } from 'pinia'

export const useNavBarStore = defineStore('navBarState', {
  state: () => {
    return {
      shown: true,
      routes: routesNavBar,
    }
  },
  actions: {
    open() {
      this.shown = true
    },
    close() {
      this.shown = false
    },
    toggle() {
      this.shown = !this.shown
    },
    updateRoutes(routes: INavBarItem[]) {
      this.routes = routes
    },
  },
})
